/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteIamRoleRequest
 */
export interface DeleteIamRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteIamRoleRequest
     */
    id: string;
}

export function DeleteIamRoleRequestFromJSON(json: any): DeleteIamRoleRequest {
    return DeleteIamRoleRequestFromJSONTyped(json, false);
}

export function DeleteIamRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteIamRoleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function DeleteIamRoleRequestToJSON(value?: DeleteIamRoleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


